<template>
  <div class="right_body">
    <search-box :fromData="fromData"  @subSearch="subSearch"></search-box>
    <list-btn :listArr="listArr"></list-btn>

    <!-- 操作按钮  -->
    <list-btn
    ref="actionbtn"
    :uploadUrl="uploadUrl"
    :downloadUrl="downloadUrl"
    @uploadExcel="uploadExcel"
    @uploadBtn="uploadBtn"
    :listArr="listArr"
    :sdata="sdata"
    @detail="goDetail"
    @edit="edit"
    @add="add"
    @del="del"
    @restore="restore"
    isAdd
    isEdit
    isDelStatus
    isExcel
    ></list-btn>

    <tab-list
      :tabList="listArr"
      :total="total"
      :pages="pages"
      :fromData="fromData" 
      :columns="tabColumns"
      tabName="order-list"
      @currentChange="currentChange"
      @changePages="changePages"
      @selectSdata="selectSdata"
      @dbClick="dbClick"
    ></tab-list>
 
    <!-- 详情 -->
    <el-dialog
      title="销售详情"
      :visible.sync="dialogFormVisible"
      customClass="dialog_detail_style"
      v-dialogDrag
      @closed="closedDialog"
    >
      <v-detail :sdata="detailSdata" class="contnet_box"></v-detail>
    </el-dialog>
  </div>
</template>

<script>
import { queryOrder } from "api/business.js";
import {excelUpload,excelDownload} from 'api/excel.js'
import listBtn from "components/btn/listBtn.vue";
import tabList from "components/table/list.vue";
import searchBox from "./components/list/search.vue";
import vDetail from "./orderDetail.vue";
import dialogDetail from 'components/common/detail.vue';

export default {
  components: {
    listBtn,
    tabList,
    searchBox,
    vDetail,
    dialogDetail
  },
  data() {
    return {
      loading:true,
      isComponentChild:false,
      dialogFormVisible: false,
      detailSdata: {},
      sdata: {},
      listArr: [],
      downloadUrl:excelDownload.material,
      uploadUrl:excelUpload.material,
      tabColumns: [
        {field: "saleVoucherNo",title: "销售订单号",need: true,width: 120,sortable: true},
        { field: "companyDesc", title: "公司", width: 100 },
        { field: "customerDesc", title: "客户", width: 100 },
        { field: "orderer", title: "联系人", width: 80 },
        { field: "telephone", title: "联系电话" },
        {
          field: "address",
          title: "送货地址"
        },

        /* {field: 'voucherHeaderTxt', title: '备注'}, */
        { field: "projectTxt", title: "备注" }
      ], //表头字段
      total: 0, //总条数
      pages: 0, //总页数
      fromData: {
        page: 1, //当前页
        pageSize: 20, //每页显示的数量,
        searchCriteria: {
          //查询的附加条件
        }
      },
      sfromData: {
        salesId: 0
      }
    };
  },
  created() {
    this.getList();
  },
  mounted(){
    this.isComponentChild = true;
  },
  methods: {
    //双击
    dbClick(data) {
      this.sdata = data;
      this.goDetail();
    },
    //选中数据
    selectSdata(data) {
      this.sdata = data;
      console.log(this.sdata);
      this.sfromData.salesId = data.salesId;
    },
    //获取列表
    async getList() {
      console.log(this.fromData)
      let res = await this.$post(queryOrder.list, this.fromData);
      console.log(res);
      if (res.status && res.data) {
        this.pages = res.data.pages;
        this.listArr = res.data.list;
        this.total = res.data.total;
      } else {
        this.pages = 0;
        this.listArr = [];
        this.total = 0;
      }
      this.loading = false;
      this.isComponentChild = true;
    },
    //当前页码改变
    currentChange(currentPage) {
      this.fromData.page = currentPage;
      this.getList();
    },
    //页码条数改变
    changePages(pages) {
      this.fromData.page = 1;
      this.fromData.pageSize = pages;
      this.getList();
    },
    //搜索
    subSearch() {
      console.log(this.fromData);
      this.fromData.page = 1;
      this.getList();
    },
    
    //新增 
    add(){
      this.$router.push({'name':'business-sale-order'});
    },
    //编辑
    edit(){
      if(!this.sdata.salesId){
        this.$message.error('请选择需要编辑的记录');
        return;
      }
      if(this.sdata.maintainStatus === "X"){
        this.$message.error('该条记录已删除，不允许编辑！');
				return;
      }
      // this.$router.push({name: 'business-sale-orderRevise', params:{id:this.sdata.salesId}});
      this.$keepAliveManager.pushRouter(this,{name: 'business-sale-orderRevise', params:{id:this.sdata.salesId}});
    },
    uploadBtn(){
      this.$refs.actionbtn.uploadDialog = true;
    },
    //上传excel
    uploadExcel(res){
      if(!res.data) return;
      if(res.data){
        console.log(res.data,88888); return;
      }
      let list = res.data.rightData;
      list.forEach((item)=>{
        let resIndex = this.selectedList.findIndex(v=>v.materialCode === item.materialCode);
        if(resIndex != -1){//存在相加
          let quantity = item.quantity +this.selectedList[resIndex].quantity;
          this.$set(this.selectedList[resIndex],'quantity',quantity);
        }else{
          let objData = {
            basicUnitCode: item.basicUnitCode,
            basicUnitDesc: item.basicUnitDesc,
            basicUnitId: item.basicUnitId,
            materialCode: item.materialCode,
            materialDesc: item.materialDesc,
            materialId: item.materialId,
            standardCurrAmount: item.purchasePrice,//价格
            quantity: item.quantity,//数量
            materialGroupDesc: item.materialGroupDesc,//物料组描述
            materialGroupId:item.materialGroupId,//物料组IE
            materialTypeId: item.materialTypeId,//物料类型
            materialTypeName: item.materialTypeName,
            "factoryCode":this.fromData.factoryCode,//工厂
            "factoryDesc":this.fromData.factoryDesc,
            "factoryId":this.fromData.factoryId,
            "inventoryCode":this.fromData.inventoryCode,//库存地
            "inventoryDesc":this.fromData.inventoryDes,
            "inventoryId":this.fromData.inventoryId,
            "supplierCode":this.noFromData.supplierCode,//供应商
            "supplierDesc":this.noFromData.supplierName,
            "supplierId":this.noFromData.supplierId,
          };
          this.selectedList.push(objData);
        }
      });

      //错误的
      let failData = res.data.failData;
      if(failData.length){
        this.isExcelError = true;
        this.excelErrorList = failData;
      }
    },
    handleSelectChange(item, key) {
      if (item.isChecked) {
        item.isChecked = false;
        this.sdata = {};
      } else {
        this.sdata = item;
        this.sdata.index = key;
        item.isChecked = true;
        this.listArr.forEach(items => {
          if (items.salesId != item.salesId) {
            items.isChecked = false;
          }
        });
        if (item.maintainStatus === "X") {
          this.sdata.isDel = true;
        } else {
          this.sdata.isDel = false;
        }
      }
    },
    //选择的改变
    changeSelect(val, item, key) {
      this.handleSelectChange(item, key);
    },
    //详情
    async goDetail() {
      if (!this.sdata.salesId) {
        this.$message.error("请选择要查看的记录");
        return;
      }
      let res = await this.$get(queryOrder.find, this.sfromData);
      this.dialogFormVisible = true;
      console.log(res.data);
      if (res.status) this.detailSdata = res.data;this.$store.state.cache.detailData = res.data
    },
    //关闭弹出层
    closedDialog() {
      this.dialogFormVisible = false;
    },
    //删除
    del() {
      let vm = this;
      console.log(vm.sdata.salesId)
      if (!this.sdata.salesId) {
        this.$message.error("请选择需要删除的");
        return;
      }
      this.$confirm("确定删除这条记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let res = await vm.$get(queryOrder.del, {
            salesId: this.sdata.salesId
          });
          const { data, msg, status, code } = res;
          console.log(res)
          if (status) {
            this.getList();
            this.sdata.isDel = true;
            this.listArr[this.sdata.index] = this.sdata;
            vm.$message.success(msg);
          } else {
            vm.$message.error(msg);
          }
        })
        .catch(() => {
          this.$message.success("已取消删除");
        });
    },
    //恢复删除
    restore() {
      let vm = this;
      if (!this.sdata.salesId) {
        this.$message.error("请选择需要恢复的物料");
        return;
      }
      this.$confirm("恢复此条记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        let res = await vm.$get(queryOrder.restore, {
          salesId: this.sdata.salesId
        });
        const { data, msg, status, code } = res;
        if (status) {
          this.getList();
          this.sdata.isDel = false;
          this.listArr[this.sdata.index] = this.sdata;
          vm.$message.success(msg);
        } else {
          vm.$message.error(msg);
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped></style>
